import React from "react";
import {Demo3Dashboard} from "./Demo3Dashboard";

export function Dashboard() {
	return <>
		<Demo3Dashboard/>
	</>;
}
